module.exports = __webpack_public_path__ + "928995be1d84907a070c59337e6f594d.pdf";